/**
 * usePlanLimits Hook (Story 2.2)
 *
 * Returns the current tenant's plan limits from the static PLAN_LIMITS config.
 * No API call needed — plan is read from the auth store (JWT claims).
 *
 * Provides a refreshPlan helper for post-upgrade token refresh.
 */

import { useAuthStore } from "../stores/authStore";
import { refreshAccessToken } from "../lib/auth";
import { PLAN_LIMITS } from "@provenleap/types";
import type { Plan, PlanLimits } from "@provenleap/types";

export interface UsePlanLimitsResult {
  limits: PlanLimits;
  plan: Plan;
  refreshPlan: () => Promise<string | null>;
}

export function usePlanLimits(): UsePlanLimitsResult {
  const plan = useAuthStore((s) => s.user?.plan) ?? "free";

  return {
    limits: PLAN_LIMITS[plan],
    plan,
    refreshPlan: refreshAccessToken,
  };
}
